import { useEffect, useState } from 'react';

import '@xyflow/react/dist/style.css';
import { ReactFlowProvider } from '@xyflow/react';

import GraphFullscreenModal from 'components/shared/GraphFullscreenModal';

import FlowGraphCanvas from './FlowGraphCanvas';
import FullscreenHeader from './FullscreenHeader';
import { FlowGraphViewProps, FlowTabType } from './types';

const FlowGraphView = (props: FlowGraphViewProps) => {
  const {
    flowTabType,
    technosphereInputs,
    technosphereOutputs,
    ecosphereInputs,
    ecosphereOutputs,
    filterValue,
    setFilterValue,
    onFilterClear,
  } = props;

  const [fullscreenTab, setFullscreenTab] = useState<FlowTabType>(flowTabType);

  useEffect(() => {
    if (props.isFullScreen) {
      setFullscreenTab(flowTabType);
    }
  }, [props.isFullScreen, flowTabType]);

  const fullscreenInputs = fullscreenTab === 'technosphere' ? technosphereInputs : ecosphereInputs;
  const fullscreenOutputs = fullscreenTab === 'technosphere' ? technosphereOutputs : ecosphereOutputs;

  return (
    <>
      {!props.isFullScreen && (
        <ReactFlowProvider>
          <FlowGraphCanvas {...props} isFullScreen={false} />
        </ReactFlowProvider>
      )}

      <GraphFullscreenModal
        isOpen={props.isFullScreen}
        onClose={() => props.setIsFullScreen(false)}
        header={
          <FullscreenHeader
            fullscreenTab={fullscreenTab}
            setFullscreenTab={setFullscreenTab}
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            onFilterClear={onFilterClear}
            onClose={() => props.setIsFullScreen(false)}
          />
        }
      >
        <FlowGraphCanvas
          {...props}
          inputs={fullscreenInputs}
          outputs={fullscreenOutputs}
          flowTabType={fullscreenTab}
          isFullScreen={true}
        />
      </GraphFullscreenModal>
    </>
  );
};

export default FlowGraphView;
